import { render } from "./DocumentComponent.vue?vue&type=template&id=74228ffa&scoped=true"
import script from "./DocumentComponent.vue?vue&type=script&lang=js"
export * from "./DocumentComponent.vue?vue&type=script&lang=js"

import "./DocumentComponent.vue?vue&type=style&index=0&id=74228ffa&scoped=true&lang=less"
import "./DocumentComponent.vue?vue&type=style&index=1&id=74228ffa&scoped=true&lang=css"
import "./DocumentComponent.vue?vue&type=style&index=2&id=74228ffa&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74228ffa"]])

export default __exports__